import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useServicesRevamp() {
  const { market } = useMarketplace()
  const {
    public: { FF_ENABLE_SERVICES_REVAMP = '' },
  } = useRuntimeConfig()

  const isEnabled = computed(() =>
    FF_ENABLE_SERVICES_REVAMP.includes(market.countryCode),
  )

  return { isEnabled }
}
